export default "__VITE_ASSET__CuGQtd5R__"